import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";

type VideoContainerProps = {
  video_url: string;
  poster: string;
  autoplay: "muted" | false;
};
const VideoContainer: React.FC<VideoContainerProps> = ({
  video_url,
  poster,
  autoplay = "muted",
}) => {
  const videoJsOptions = {
    controls: true,
    autoplay,
    preload: "auto",
    aspectRatio: "9:16",
    sources: [
      {
        src: video_url,
        type: "video/mp4",
      },
    ],
  };
  return (
    <div className={`video_parent_cont`}>
      <div className="video-container theater-mode">
        <VideoPlayer options={videoJsOptions} poster={poster} />
      </div>
    </div>
  );
};

type VideoPlayerProps = {
  options: any;
  poster: string;
};

const VideoPlayer: React.FC<VideoPlayerProps> = ({ options, poster }) => {
  const videoNode = useRef(null);
  const player = useRef<any>(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (videoNode.current && !initialized.current) {
      initialized.current = true; // Prevent duplicate initialization
      player.current = videojs(videoNode.current, {
        ...options,
      });
      // player.current.autoplay("muted");
    }

    // Clean up player on dismount
    return () => {
      if (player.current) {
        player.current.dispose();
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="video-cont">
      <video
        ref={videoNode}
        className="video-js"
        controlsList="nodownload"
        poster={poster}
      />
    </div>
  );
};

export default VideoContainer;
